(function() {
'use strict';

/*
 * Depends:
 *   jquery.ui.core.js
 *   jquery.ui.widget.js
 */
(function($) {
    $.widget('trp.modal', {

        options: {
            template: '<div class="modal-overlay">' +
                      '   <div class="lightbox">' +
                      '       <div class="lightbox-inner">' +
                      '           <div class="stage">' +
                      '               <div class="modal-header">' +
                      '                   <span class="modal-title"></span>' +
                      '                   <a href="#" class="close close-btn"></a>' +
                      '               </div>' +
                      '               <div class="modal-content"></div>' +
                      '           </div>' +
                      '       </div>' +
                      '   </div>' +
                      '</div>',
            fadeSpeed: 200,
            easing: 'swing',
            clickOffToClose: false
        },

        _create() {
            // element refs
            this.$lightbox = null;
            this.$stage = null;
            this.$loader = null;

            this.isShown = false;

            this._show();
        },

        _show() {
            if (this.isShown) { return; }

            this.isShown = true;

            this._createLightbox();
        },


        _createLightbox() {
            const self = this;

            // create lightbox using template
            this.$lightbox = $(this.options.template)
                            .appendTo(document.body)
                            .fadeIn(this.options.fadeSpeed, this.options.easing, $.proxy());

            // set refs to child elements
            this.$stage = this.$lightbox.find('.stage');
            this.$loader = this.$stage.find('.loader');

            this.$stage.find('a.close-btn')
            .on('click.modal', $.proxy(function(e) {
                e.preventDefault();
                this._trigger('closeClicked', e);
                this._hide();
            }, this));


            this._getContent(function(content) {
                self.$loader.hide();

                // set the content
                if (content) { self.$stage.find('.modal-content').html(content); }
            });

            // bind for any confirmation buttons
            this.$stage.find('a.ok-btn')
            .on('click.modal', $.proxy(function(e) {
                e.preventDefault();
                this._trigger('okClicked', e);
                this._hide();
            }, this));

            this.$stage.find('a.cancel-btn')
            .on('click.modal', $.proxy(function(e) {
                e.preventDefault();
                self._trigger('cancelClicked', e);
                this._hide();
            }, this));

            if (this.options.clickOffToClose) {
                // hide if user clicks outside the lightbox
                this.$lightbox.on('click.modal', $.proxy(this._hide, this));
                this.$stage.on('click.modal', function(e) { e.stopPropagation(); });

                // support keyboard commands
                $('html').on('keyup.modal', $.proxy(function(e) {
                    return (e.which === 27 && this._hide()); // escape to close
                }, this));
            }

            this._trigger('created');
        },

        _getContent(callback) {
            if (typeof this.options.content === 'function') {
                // default behaviour using content function
                this.options.content.call(this.element[0], function(response) {
                    callback(response);
                });
            } else {
                // just return content as is
                callback(this.options.content);
            }
        },

        _hide() {
            if (!this.isShown) { return; }

            this.isShown = false;


            // fade out the overlay and destroy
            this.$lightbox.fadeOut(200, this.options.easing, $.proxy(function() {
                this.destroy();
            }, this));

            this._trigger('hidden');
        },

        _destroy() {
            this.$lightbox.remove();
            //this.$overlay.remove();
            $('html').off('keyup.modal');
        }

    });
})(window.jQuery);
})();
